import Resources from '../Resources';

export default {
  attributes: {
    resources: Resources,
  },
};
